/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import { RegularButton } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import excelExportService from 'src/services/excel-export.service';
import DependentTable from 'src/modules/personal-info/components/dependent-form-table';
import { IDependent } from 'src/interfaces';
// import { useLocalStorage } from 'src/hooks/useLocalStorage';
import arrowSvg from 'src/assets/arrowExpand.svg';
import { MainTitle, EmergencyHeader, SeparatorLineStraight, ExpandIcon, Collapsible, BelowTitle } from './styles';
import { PersonalInfoForm } from '../..';
import { PersonalDependentsModal } from '../personal-dependents-modal';

const ContactsForm: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  const [contacts, setContacts] = useState<IDependent[]>([]);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);

  useEffect(() => {
    // eslint-disable-next-line max-len
    if (
      personalInfo?.emergencyContacts ||
      personalInfo?.beneficiaries ||
      personalInfo?.dependents ||
      personalInfo?.pendingContacts
    ) {
      const storedContacts: IDependent[] = [
        ...(personalInfo.dependents ?? []),
        ...(personalInfo.beneficiaries ?? []),
        ...(personalInfo?.emergencyContacts ?? []),
        ...(personalInfo?.pendingContacts ?? []),
      ];

      const uniqueMap = new Map<string, IDependent>();

      // eslint-disable-next-line no-restricted-syntax
      for (const cnt of storedContacts) {
        if (cnt.id) {
          uniqueMap.set(cnt.id, cnt);
        }
      }

      setContacts(Array.from(uniqueMap.values()));
    }
  }, [personalInfo?.emergencyContacts, personalInfo?.dependents, personalInfo?.pendingContacts]);

  // eslint-disable-next-line no-unused-vars
  const addDependent = () => {
    setIsOpen(!modalIsOpen);
    setIsUpdate(false);
  };

  const getExcelLink = () => excelExportService.getDependentsXLSLink(personalInfo?.id || '');

  const [isTableOpen, setIsTableOpen] = useState(true);
  const expandTab = () => {
    setIsTableOpen(!isTableOpen);
  };

  return (
    <>
      <PersonalDependentsModal updateDependent={[]} isOpen={modalIsOpen} setIsOpen={setIsOpen} isUpdate={isUpdate} />
      <div style={{ boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}>
        <EmergencyHeader>
          <MainTitle>
            <ExpandIcon src={arrowSvg} onClick={() => expandTab()} isOpen={!isTableOpen} />
            {t('personalInfo.dependents.title')}
          </MainTitle>
          <div style={{ marginTop: '15px', marginRight: '27px' }}>
            <a
              href={getExcelLink()}
              download
              target="_blank"
              style={{
                visibility: contacts.length ? 'visible' : 'hidden',
              }}
              rel="noreferrer"
            >
              <RegularButton type="button">{t('global.form.exportExcel')}</RegularButton>
            </a>
            <RegularButton type="button" onClick={addDependent}>
              {t('global.form.add')}
            </RegularButton>
          </div>
        </EmergencyHeader>
        <SeparatorLineStraight />
        <Collapsible isOpen={isTableOpen}>
          <DependentTable personalInfo={personalInfo} />
        </Collapsible>
        <BelowTitle />
      </div>
    </>
  );
};

export default ContactsForm;
